import { externalUrls } from '../constants';

export const createSolutionRoute = (url: string): string => {
    if (url) {
        try {
            const urlObj = new URL(url);
            return `${urlObj.pathname}`.replace('//', '/');
        } catch (err) {
            return url;
        }
    }
    return '';
};

export const buildTargetRoute = (url: string): string => {
    if (url) {
        try {
            const urlObj = new URL(url);
            const pathComponents = urlObj.pathname.split('/');
            if (urlObj.search) {
                return `/target${urlObj.search}`;
            }
            return `/target?tqssurveyid=${pathComponents.pop()}`;

        } catch (e) {
            return '';
        }
    }
    return '';
};
export const buildDefineRoute = (url: string): string => {
    if (url) {
        const defineUrl = `/${url.split("/").pop()}`;
        return defineUrl.includes('define') ? defineUrl : `/define${defineUrl}`;
    }
    return '';
};

export const buildBuildRoute = (url: string): string => {
    if (url) {
        const buildUrl = `/${url.split("/").pop()}`;
        return buildUrl.includes('build') ? buildUrl : `/build${buildUrl}`;
    }
    return '';
};

export const checkIsExternalLink = (url?: string) =>
    Boolean(
        url && Object.values(externalUrls).find(externalUrl => url.toLowerCase().includes(externalUrl.toLowerCase()))
    );

export const convertToWwwUrl = (inputUrl: string): string => {
    try {
        const urlObject = new URL(inputUrl);
        if (urlObject.hostname.startsWith('www.')) {
            return inputUrl;
        }
        urlObject.hostname = `www.${urlObject.hostname}`;
        return urlObject.href;
    } catch (error) {
        return inputUrl;
    }
};

